import React from "react";
import SurveyCondensedTable from "../../../SurveyCondensedTable"
import { NumberFormat, PlaceholderFormat } from "../../../../Enums/constants"
import { observer } from "mobx-react";
import { handleExpensesData, expensesCellRenderer, loadExpensesTableErrors, getHiddenExpensesColumns } from "./ExpensesTableHandler";

const ExpensesTable = observer((props) => {
    let currencyPlaceHolderThousandsForHeader = `|${PlaceholderFormat.CURRENCY_THOUSANDS}|`;

    return (
        <SurveyCondensedTable tableName={"Expenses"}
            handleData={handleExpensesData}
            cellRenderer={expensesCellRenderer}
            loadTableErrors={loadExpensesTableErrors}
            headers={["SupportActivityName", "SupportCosts", "SupportNumFTE", "RowID"]}
            columns={[
                { data: 'SupportActivityName', readOnly: true },
                { data: 'SupportCosts' },
                { data: 'SupportNumFTE' },
                { data: 'RowID' }
            ]}
            hideExtraColumns={getHiddenExpensesColumns}
            colWidths={['440px', '130px', '130px', '75px']}
            formatting={['', NumberFormat.MONEYTHOUSAND, NumberFormat.DECIMAL1]}
            nestedHeaders={[
                ['Investment governance, operations and support activities', `Cost (${currencyPlaceHolderThousandsForHeader})`, '# of FTE']
            ]}
            helpText={[
                "",
                "Costs<br/><br/>Attribute 100% of investment governance, operations and support costs(excluding transaction costs) to the activities in the table below. <br/><br/>Do not include direct Front Office investment costs. These should be included in the table above. <br/><br/>Do not include pension administration costs, such as the cost of serving members. <br/><br/>All investment related costs(excluding manager fees and transaction costs) should be captured in either this table, or the Front Office investment cost table above.",
                "# of Investment FTE<br/><br/>Support FTE includes staff in governance, and support services such as CEO, HR, legal, public relations, building and utilities, finance, IT, and “corporate overhead”. These staff should be attributed between investment and non-investment activities such as administering member benefits (if applicable). Only the FTE attributed to investments should be included on this survey. 100% of staff in dedicated investment organizations should be accounted for on this survey<br/><br/>Include full time permanent salaried employees and the FTE of long and short term contract individuals dedicated to your organization that are working onsite or working full-time for your fund on a project or in a role supervised by your staff. Do not include FTE at external consultants or service providers if they are not being supervised by your staff, even if they are dedicated to serving your organization. Do not include Board members.",
                ""
            ]}
            includeTotalRow
        />
    );

});
export default ExpensesTable;